export default class TripRateDay {
    period: string | null = null;
    numberOfDays: number | null = null;
    averageParameter: number | null = null;
    tripRate: number | null = null;
    tripRatePreCalculation: number | null = null
}